export default "__VITE_ASSET__244a453f__"